export default __webpack_public_path__ + "332e0d88014989a39656a1994ca90994.svg";